import api from '@/plugins/api/instance'

const state = () => ({
  abortController: null,
  loaded: false,
  items: [],
  currentPage: 1,
  itemsPerPage: 6,
  numberOfPages: 1,
  numberOfTotalItems: 6
})

const getters = {
  getParams: (state, getters, rootState, rootGetters) => {
    const params = {
      pagination: true,
      page: state.currentPage,
      itemsPerPage: state.itemsPerPage,
      ...rootGetters['filter/getParams']
    }
    if (!['default', '8300'].includes(rootState.brand)) {
      params['brandDivisions.brand'] = rootState.brand
    }
    return params
  }
}

const mutations = {
  setLoaded (state, payload) {
    state.loaded = payload
  },
  setItems (state, payload) {
    state.items = [...payload]
  },
  addItems (state, payload) {
    state.items = [...state.items, ...payload]
  },
  resetCurrentPage (state) {
    state.currentPage = 1
  },
  increaseCurrentPage (state) {
    state.currentPage += 1
  },
  setNumberOfPages (state, payload) {
    state.numberOfPages = payload
  },
  setNumberOfTotalItems (state, payload) {
    state.numberOfTotalItems = payload
  }
}

const actions = {
  async get ({ state, commit, getters }) {
    commit('setLoaded', false)
    try {
      // abort running request
      if (state.abortController) {
        state.abortController.abort()
      }

      state.abortController = new AbortController()

      // start new request
      const response = await api.get('dealer', {
        params: getters.getParams,
        signal: state.abortController.signal
      })
      state.currentPage === 1
        ? commit('setItems', response.data['hydra:member'])
        : commit('addItems', response.data['hydra:member'])
      commit('setNumberOfPages', Math.ceil(response.data['hydra:totalItems'] / state.itemsPerPage))
      commit('setNumberOfTotalItems', response.data['hydra:totalItems'])
      commit('setLoaded', true)
      return response
    } catch (e) {
      commit('setErrors', e, { root: true })
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
